export default "__VITE_ASSET__1nxU057l__"